module.exports = __webpack_public_path__ + "img/tn-timeline-main-5.5426b754.jpg";